export type CompetitionSubPage = "overview" | "news" | "videos" | "standings" | "matches" | "teams" | "draw";

function normalize(path: string): string {
    const withoutQuery = path.split(/[?#]/)[0];
    let decoded = withoutQuery;
    try {
        decoded = decodeURIComponent(withoutQuery);
    } catch {
        // keep the raw path when it is not valid percent-encoding
    }
    return decoded.length > 1 ? decoded.replace(/\/+$/, "") : decoded;
}

/**
 * Resolves which competition sub-page a pathname belongs to: the entry whose href equals the
 * pathname or is a path prefix of it (longest match wins). "overview" when nothing matches.
 */
export function activeCompetitionSubPage(
    pathname: string,
    hrefs: { key: CompetitionSubPage; href: string }[]
): CompetitionSubPage {
    const path = normalize(pathname);
    let best: CompetitionSubPage = "overview";
    let bestLength = -1;
    for (const { key, href } of hrefs) {
        const base = normalize(href);
        const matches = path === base || path.startsWith(`${base}/`);
        if (matches && base.length > bestLength) {
            best = key;
            bestLength = base.length;
        }
    }
    return best;
}
